export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const CHECK_AUTH = 'CHECK_AUTH'
export const RECOVERY_PASS = 'RECOVERY_PASS'
export const FECTH_AUTH = 'FECTH_AUTH'

export const FECTH_PROJECTS = 'fecthProjects'
export const FECTH_PROJECT = 'fecthProject'

export const FECTH_DASHBOARD = 'fecthDashboard'

export const FECTH_SIDEBAR = 'fecthSidebar'
export const FECTH_NAME_SIDEBAR = 'FECTH_NAME_SIDEBAR'

export const FECTH_DB_TABLES = 'fecthDbTables'
export const FECTH_DB_TABLE = 'fecthDbTable'
export const FECTH_CHECK_BUILDER = 'fecthCheckBuilder'

export const FECTH_TIPO_MENU = 'fecthTipoMenu'
export const FECTH_TEMPLATE_OPTIONS = 'fecthTemplateOptions'
export const FECTH_TIPO_TEMPLATE_DESKTOP = 'FECTH_TIPO_TEMPLATE_DESKTOP'
export const FECTH_PLUGINS_PROJECT = 'FECTH_PLUGINS_PROJECT'
export const FECTH_USER_ACCESS = 'FECTH_USER_ACCESS'

export const CHECK_TMP_RECOVERY_TOKEN = 'CHECK_TMP_RECOVERY_TOKEN'



// WEBPACK FOOTER //
// ./src/store/actions.type.js